<template>
  <b-navbar fixed-top shadow>
    <template slot="brand">
      <b-navbar-item class="is-paddingless pl-3" tag="router-link" :to="{ path: '/' }">
        <img
          src=" https://costuto-public.s3.eu-central-1.amazonaws.com/images/costuto_logo.png"
          alt="Lightweight UI components for Vue.js based on Bulma"
        />
      </b-navbar-item>
    </template>
    <template slot="start">
      <b-navbar-item @keyup.native.enter="search">
        <b-tooltip type="is-danger" label="Not yet implemented" position="is-bottom">
          <b-input placeholder="Search..." type="search" icon="magnify" disabled>
          </b-input>
        </b-tooltip>
      </b-navbar-item>
      <b-navbar-item tag="router-link" :to="{ path: '/' }">
        <div class="block">
          <b-icon icon="home-outline" size="is-medium" type="is-primary"> </b-icon>
        </div>
      </b-navbar-item>
      <b-navbar-item tag="router-link" :to="{ path: `/news` }">
        <div>
          <b-icon icon="email-outline" size="is-small"> </b-icon>
          <span> News</span>
        </div>
      </b-navbar-item>
      <b-navbar-item
        v-if="isLoggedIn && currentUser"
        tag="router-link"
        :to="{ path: `/users/${currentUser.attributes.username}#projects` }"
      >
        <div>
          <b-icon icon="folder-multiple-outline" size="is-small"> </b-icon>
          <span> Projects</span>
        </div>
      </b-navbar-item>
      <b-navbar-item
        v-if="isLoggedIn && currentUser"
        tag="router-link"
        :to="{ path: `/users/${currentUser.attributes.username}/collections` }"
      >
        <div>
          <b-icon icon="treasure-chest" size="is-small"> </b-icon>
          <span> Collections</span>
        </div>
      </b-navbar-item>
    </template>

    <template slot="end">
      <b-navbar-item tag="div">
        <locale-switcher />
      </b-navbar-item>

      <b-navbar-item v-if="isLoggedIn && currentUser" tag="div">
        <router-link :to="{ path: `/users/${currentUser.attributes.username}` }">
          <div class="columns is-vcentered is-marginless">
            <div class="column is-narrow">
              <figure class="image is-24x24">
                <img
                  style="border-radius: 50%; border: 0.1rem solid #3acfb9"
                  :src="currentUser.attributes.avatar.url"
                />
              </figure>
            </div>
            <div class="column is-paddingless">
              <span> {{ currentUser.attributes.cosplayer_name }}</span>
            </div>
          </div>
        </router-link>
      </b-navbar-item>
      <b-navbar-item tag="div">
          <notifications-dropdown  v-if="isLoggedIn && currentUser"
            @consult="readNotification"
            :active="activeNotification"
          />
      </b-navbar-item>
      <b-navbar-item tag="div">
        <b-dropdown
          v-if="isLoggedIn && currentUser"
          position="is-bottom-left"
          append-to-body
          aria-role="menu"
        >
          <a slot="trigger" role="button">
            <b-icon icon="cogs"></b-icon>
          </a>

          <b-dropdown-item value="profile" has-link aria-role="menuitem">
            <router-link :to="{ path: `/users/${currentUser.attributes.username}` }">
              <b-icon icon="account"></b-icon>
              Profile
            </router-link>
          </b-dropdown-item>

          <hr class="dropdown-divider" />

          <b-dropdown-item has-link value="home" aria-role="menuitem">
            <router-link :to="{ path: `/` }">
              <b-icon icon="home"></b-icon>
              Home
            </router-link>
          </b-dropdown-item>
          <b-dropdown-item has-link value="Collections" aria-role="menuitem">
            <router-link
              :to="{ path: `/users/${currentUser.attributes.username}/collections` }"
            >
              <b-icon icon="book-open"></b-icon>
              Collections
            </router-link>
          </b-dropdown-item>

          <hr class="dropdown-divider" aria-role="menuitem" />
          <b-dropdown-item value="settings" has-link>
            <router-link :to="{ path: `/settings` }">
              <b-icon icon="cog-outline"></b-icon>
              Settings
            </router-link>
          </b-dropdown-item>
          <b-dropdown-item value="logout" aria-role="menuitem" @click="logout">
            <b-icon icon="logout"></b-icon>
            Logout
          </b-dropdown-item>
        </b-dropdown>

        <div v-else class="buttons">
          <router-link :to="{ name: 'register' }" class="button is-primary">
            <strong>Sign up</strong>
          </router-link>
          <button class="button is-light" @click="isComponentModalActive = true">
            {{ $t("buttons.login") }}
          </button>
        </div>
        <b-modal
          :active.sync="isComponentModalActive"
          has-modal-card
          trap-focus
          aria-role="dialog"
          aria-modal
        >
          <login-form :session="session"></login-form>
        </b-modal>
      </b-navbar-item>
    </template>
  </b-navbar>
</template>

<script>
import { mapGetters } from 'vuex'
import Login from '@/components/modals/Login.vue'
import LocaleSwitcher from '@/components/buttons/LocaleSwitcher'
import NotificationsDropdown from '@/components/partials/Navbar/NotificationsDropdown'
export default {
  channels: {
    UserChannel: {
      connected () {
        console.log('connected to chan')
      },
      rejected () {},
      received (data) {
        console.log('reei')
        this.$buefy.toast.open({
          message: 'You have a new notification!',
          type: 'is-warning'
        })
        this.$store.dispatch('notifications/activateNotification')
        this.$store.dispatch('notifications/addNotification', JSON.parse(data).data)
      },
      disconnected () {
        console.log('I have been disco')
      }
    }
  },
  components: {
    NotificationsDropdown,
    'login-form': Login,
    LocaleSwitcher
  },
  computed: {
    ...mapGetters({
      isLoggedIn: 'isLoggedIn',
      currentUser: 'currentUser'
    }),
    ...mapGetters('notifications', ['activeNotification'])
  },
  methods: {
    search () {
      alert('Searching')
    },
    logout () {
      this.$store
        .dispatch('sessions/destroy')
        .then(() => {
          this.$router.push('/').catch((_) => {})
        })
        .catch((error) => {
          console.log('Errors')
          console.log(error.response)
        })
    },
    readNotification () {
      this.$store.dispatch('notifications/consultNotifications')
    }
  },
  data () {
    return {
      session: {
        login: null,
        password: null
      },
      isComponentModalActive: false
    }
  }
}
</script>
